export const CONTACT_EMAIL = "sanjib@flavoria.in";

export const DISCLAIMER = [
  {
    n: 1,
    h: "General Information Only",
    paras: [
      'Flavoria ("we," "us," "our," or "the Site") curates and surfaces recipe suggestions from third-party creators, public sources, and user submissions for general informational and entertainment purposes only. Nothing on this Site constitutes professional culinary, nutritional, dietary, or medical advice.',
    ],
  },
  {
    n: 2,
    h: "No Warranty on Recipe Accuracy",
    paras: [
      "While we make reasonable efforts to curate high-quality recipes, we do not guarantee the accuracy, completeness, reliability, or suitability of any recipe, ingredient list, cooking time, measurement, or instruction displayed on the Site. Cooking results may vary based on equipment, ingredient quality, altitude, and individual technique.",
    ],
  },
  {
    n: 3,
    h: "Allergy and Dietary Warning",
    paras: [
      "Always independently verify all ingredients before preparing or consuming any recipe, particularly if you or anyone you are cooking for has food allergies, intolerances, or dietary restrictions (including but not limited to nut, dairy, gluten, shellfish, or soy allergies, or vegan, vegetarian, halal, kosher, or other dietary requirements). Ingredient lists displayed on the Site may be incomplete, mislabeled, or updated without our knowledge. We are not liable for any allergic reaction, illness, or adverse health event arising from reliance on content displayed on the Site.",
    ],
  },
  {
    n: 4,
    h: "No Medical or Nutritional Advice",
    paras: [
      "Any nutritional information (calories, macros, dietary claims, etc.) displayed on the Site is provided for general reference only and may be estimated or sourced from third parties. It is not a substitute for advice from a qualified physician, dietitian, or nutritionist. Consult a healthcare professional before making dietary changes, especially if you have a pre-existing medical condition.",
    ],
  },
  {
    n: 5,
    h: "Cooking Safety",
    paras: [
      "Certain recipes may involve inherently hazardous techniques or equipment, including but not limited to knives, hot oil, pressure cookers, open flames, and food processors. You assume all risk associated with preparing any recipe found on the Site. Exercise caution, follow manufacturer safety instructions for all equipment, and supervise children at all times in the kitchen.",
    ],
  },
  {
    n: 6,
    h: "Third-Party and User-Submitted Content",
    paras: [
      "Recipes on Flavoria may be sourced from independent creators through our Creator Program, aggregated from publicly available sources, or embedded from third-party platforms such as YouTube.",
      "We do not independently verify the accuracy, originality, or safety of creator-submitted content. Creators are solely responsible for ensuring they hold the necessary rights to any content they submit. Embedding a third-party video or linking to an external recipe does not imply endorsement, partnership, or verification by Flavoria.",
      "If you are a rights holder and believe content on Flavoria infringes your copyright or other rights, please contact us at sanjib@flavoria.in with details, and we will review and address the request promptly.",
    ],
  },
  {
    n: 7,
    h: "Affiliate and Advertising Disclosure",
    paras: [
      "Flavoria participates in affiliate marketing programs, including the Amazon Associates Program and other affiliate networks. This means we may earn a commission on qualifying purchases made through links on this Site, at no additional cost to you.",
      "As an Amazon Associate, we earn from qualifying purchases.",
      "The Site also displays third-party advertisements served through Google AdSense and/or other advertising networks. These networks may use cookies and similar technologies to serve ads based on your visits to this and other websites. We do not control the content of third-party advertisements and are not responsible for the products, services, or claims made by advertisers.",
    ],
  },
  {
    n: 8,
    h: "External Links",
    paras: [
      "The Site may contain links to third-party websites, apps, or services (including but not limited to Amazon, IKEA, YouTube, and other retail or content platforms) for your convenience. We do not control and are not responsible for the content, accuracy, privacy practices, or terms of use of any linked third-party site. Accessing linked sites is at your own risk and subject to that site's own terms and policies.",
    ],
  },
  {
    n: 9,
    h: "No Professional Relationship",
    paras: [
      "Use of the Site does not create any advisory, professional, fiduciary, or partnership relationship between you and Flavoria.",
    ],
  },
  {
    n: 10,
    h: "Limitation of Liability",
    paras: [
      "To the fullest extent permitted by applicable law, Flavoria, its owners, operators, and affiliates shall not be liable for any direct, indirect, incidental, consequential, special, or exemplary damages — including but not limited to personal injury, illness, allergic reaction, property damage, or financial loss — arising out of or in connection with your use of, or inability to use, the Site, or reliance on any content, recipe, product recommendation, or third-party link provided on the Site.",
    ],
  },
  {
    n: 11,
    h: "Changes to Content and This Disclaimer",
    paras: [
      "We reserve the right to modify, update, or remove any recipe, feature, advertisement, affiliate relationship, or provision of this Disclaimer at any time without prior notice. Continued use of the Site after changes constitutes acceptance of the updated terms.",
    ],
  },
  {
    n: 12,
    h: "Governing Law",
    paras: [
      "This Disclaimer shall be governed by and construed in accordance with the laws of India, without regard to conflict of law principles. Any disputes arising under this Disclaimer shall be subject to the exclusive jurisdiction of the courts located in India.",
    ],
  },
  {
    n: 13,
    h: "Contact Us",
    paras: [
      "If you have any questions about this Disclaimer, please contact us at sanjib@flavoria.in.",
    ],
  },
];
